import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Table,
  Col,
  Alert,
  Label,
} from "reactstrap";
import {
  resourcesBranch,
  resourcesBranchGeo,
} from "../../../helpers/backend_helper";
import AddGeoModal from "./AddGeoModal";
import InitMap from "./InitMap";
import EditMap from "./EditMap";
import classNames, { classname } from "classnames";

const RouteModal = ({ modal, setModal }) => {
  const [items, setItems] = useState([]);
  const [item, setItem] = useState(null);
  const [branch, setBranch] = useState(null);
  const [geofences, setGeofences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingUpdateGeo, setLoadingUpdateGeo] = useState(false);
  const [line, setLine] = useState([]);
  const [edit, setEdit] = useState(false);
  const [errorGeneral, setErrorGeneral] = useState(null);
  const [newGeo, setNewGeo] = useState({ show: false, update: false });

  const handleClose = () => {
    setModal({ ...modal, show: false, id: null });
  };

  const loadBranch = async () => {
    const response = await resourcesBranch(
      "show",
      { params: { startPath: true } },
      modal.id
    );
    setBranch(response.branch);
    setGeofences(
      response.branch?.geofences
        ? response.branch?.geofences?.map((e) => e.geo)
        : []
    );

    if (
      response.branch?.positions?.length == 0 &&
      response?.positions?.length > 0
    ) {
      let tempPath = response.positions
        .filter((e, idx, data) => {
          if (idx == 0) return true;
          let previous = data[idx - 1];
          if (
            e.attributes.totalDistance - previous.attributes.totalDistance <
            20
          )
            return false;
          return true;
        })
        .map((e) => [e.latitude, e.longitude]);
      //setLine(LineUtil.simplify(tempPath, 0.001));
      setLine(tempPath);
    }
  };

  useEffect(() => {
    loadBranch();
  }, []);

  const save = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const response = await resourcesBranchGeo("post", items);
        setEdit(false);
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    }
  };

  const validate = () => {
    let errorsNo = 0;
    let base = items.filter((item) => item.is_base == true);
    errorsNo = base.length == 0 ? errorsNo + 1 : errorsNo;
    errorsNo = items.length == 0 ? errorsNo + 1 : errorsNo;

    if (errorsNo == 0) {
      setErrorGeneral(null);
      return true;
    }
    setErrorGeneral(
      "Debe agregar almenos 1 geocerca e indicar una geocerca intermedia."
    );
    return false;
  };

  const updateGeofences = async () => {
    setLoadingUpdateGeo(true);
    try {
      const response = await resourcesBranch(
        "show",
        { params: { startPath: true } },
        modal.id
      );
    } catch (error) {
      console.log("error", error);
    }
    setLoadingUpdateGeo(false);
  };

  return (
    <div>
      <Modal
        isOpen={modal.show}
        className="modal-dialog modal-xl"
        role="document"
      >
        <ModalHeader className="bg-primary">{"Recorrido"}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12 mb-2 text-end"></div>
            <Col sm="12">
              {
                //JSON.stringify(branch)
              }
              {
                //JSON.stringify(line.length)
              }
              {branch?.positions?.length == 0 && (
                <>
                  <Alert color="warning">
                    Se ha obtenido el corrido de una salida del ramal para
                    inicializar el recorrido. Si es incorrecto el recorrido
                    puede cerrar y volver a abrir la ventana para cargar los
                    datos de otra salida.
                  </Alert>
                  {line.length >= 2 && (
                    <InitMap
                      line={line}
                      setLine={setLine}
                      branch={branch}
                      setBranch={setBranch}
                    />
                  )}
                </>
              )}
            </Col>
            {branch?.positions?.length > 0 && (
              <>
                <Col sm="6">
                  <EditMap
                    geofences={geofences}
                    positions={branch?.positions}
                    branch={branch}
                    item={item}
                    setBranch={setBranch}
                  />
                </Col>
                <Col sm="6">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "500px" }}
                  >
                    <Table className="table table-sm">
                      <thead>
                        <tr className="table-light">
                          <th width="20">#</th>
                          <th>Geocerca</th>
                          <th width="150">Ubicación</th>
                          <th>Tiempo</th>
                          <th>Distance</th>
                          <th className="d-none" width="80">
                            Acciones
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {branch?.positions?.map((stop, index) => (
                          <tr
                            key={stop.id}
                            className={classNames({
                              bg_pin_selected: stop.id == item?.id,
                            })}
                          >
                            <td>
                              <small>{index + 1}</small>
                            </td>
                            <td className="">
                              <small>
                                {stop.branch_geofence?.geo?.numero ?? ""}{" "}
                                {stop.branch_geofence?.geo?.alias ?? ""}
                              </small>
                            </td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm me-2 mt-2 float-start d-inline-block"
                                title="Editar ramal"
                                onClick={() => [setItem(stop)]}
                              >
                                <i className="fas fa-map-marker-alt"></i>
                              </button>
                              <small>
                                {stop.lat} {stop.lng}
                              </small>
                            </td>
                            <td>
                              <small>{stop.time_dst_accum} min</small>
                            </td>
                            <td>
                              <small>
                                {stop?.distance_accum
                                  ? (
                                      Number(stop?.distance_accum) / 1000
                                    ).toFixed(2)
                                  : "-"}{" "}
                                km
                              </small>
                            </td>
                            <td className="d-none">
                              <div className="d-flex justify-content-between">
                                <div className="me-1">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    title="Editar ramal"
                                    onClick={() => [setItem(stop)]}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </div>
                                <div className="p-0">
                                  <button
                                    className="btn btn-danger btn-sm "
                                    title="Eliminar ramal"
                                    onClick={() => {
                                      console.log("delete");
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </>
            )}
          </div>
          {errorGeneral && (
            <div className="alert alert-warning">{errorGeneral}</div>
          )}
        </ModalBody>
        <ModalFooter>
          {edit && (
            <Button color="primary" onClick={save} disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar Cambios
            </Button>
          )}
          {branch?.positions?.length > 0 && (
          <Button
            color="primary"
            onClick={() => updateGeofences()}
            disabled={loadingUpdateGeo}
          >
            {loadingUpdateGeo && <Spinner size="sm"></Spinner>}{" "}
            <i className="fa fa-sync"></i> Update Geofences
          </Button>
          )}
          <Button color="secondary" onClick={handleClose}>
            <i className="fa fa-times"></i> Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      {newGeo.show && (
        <AddGeoModal
          newGeo={newGeo}
          setNewGeo={setNewGeo}
          setItem={setItem}
          item={item}
          setItems={setItems}
          items={items}
          setEdit={setEdit}
        />
      )}
    </div>
  );
};

export default RouteModal;
